import React, { Component } from "react";
import {
  Modal,
  NavBar,
  Icon,
  Button,
  List,
  InputItem,
  Checkbox,
  Picker,
  Accordion,
  Toast,
  WingBlank,
  WhiteSpace,
} from "antd-mobile";
import SelectPrefixList from './SelectPrefixList'
import "./clockinICCID.scss";
import { createForm } from "rc-form";
import { connect } from "dva";
import axios from "@/service/axios";
import company_sys from "../../assets/images/saoyisao.png";
import UserSelectGroups from "../userManage/userAdd/userSelectGroup";
import DefaultGroup from "../userManage/userAdd/defaultGroup"
import NoneDatas from "../../components/noneDatas"


const CheckboxItem = Checkbox.CheckboxItem;
const Item = List.Item;
const alert = Modal.alert

const loginAdminMsg =
  sessionStorage.getItem("loginMsg") &&
  JSON.parse(sessionStorage.getItem("loginMsg"));


// 前缀列表样式(抽屉)
const selectedContainer = {
  position: "fixed",
  width: "100%",
  top: "0px",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s",
};

@connect()
export class ClockinICCID extends Component {
  state = {
    getICCID:'',
    // getICCID: '11111222223333344447',
    iccidList: [],
    isDef: true,
    isPrefix: false,
    funcGidArr: [],
    funcsList: [],
    preValidateMonth: -1,
    drawerLeftG: document.body.clientWidth,   // 选择群组组件侧边边距
    drawerLeftDefault: document.body.clientWidth, // 选择默认群组组件侧边边距
    drawerLeft: document.body.clientWidth,  // 选择前缀群组组件侧边边距
    userType: 0       // 创建账号选择的功能组类型
  };

  componentWillMount() {
    console.log('props~',this.props)
    window.wx.config(JSON.parse(localStorage.getItem('configData')));
    window.wx.ready(() => {
      console.log("cfg-初始化完成");
    });
    this.props.getFuncList();
    console.log('this.props.getFuncList();',this.props.getFuncList())
    this.getPreValidateMonth();
  }

  // 表单提交
  onSave() {
    this.props.form.validateFields({ force: true }, error => {
      console.log(error);
      if (!error) {
        // 判断提交类型
        if(this.state.isDef) {
          // 批量扫码提交
          this.creatUser2()
        } else {
          // 前缀群组提交
          this.DYcamera()
        }
      }
    })
  }

  //获取上级管理员的时间
  getPreValidateMonth() {
    return new Promise((resolve, reject) => {
      axios.get("/api/user/admin/preferentialMonths/get").then(res => {
        console.log('管理员的时间',res)
        if (res.status == 200 && res.data) {
          if (res.data >= 0) {
            this.setState({
              preValidateMonth: res.data,
            });
          }
        }
      })
    });
  }
  // 微信扫码
  DYcamera = () => {
    console.log("vx1")
    window.wx.scanQRCode({
      needResult: 1,
      desc: "scanQRCode desc",
      success: (res) => {
        if(res.resultStr.indexOf(',')!=-1){
          var result =  res.resultStr.split(',')[1];
          this.setState({
            getICCID: result
          },()=>{
            this.creatUser()
          })
        }
        else{
          this.setState({
            getICCID: res.resultStr
          },()=>{
            this.creatUser()
          })
        }
      }
    })
  }
  // 微信连续扫码
  DYcamera2 = () => {
    console.log("vx2", this.state.iccidList)
    window.wx.scanQRCode({
      needResult: 1,
      desc: "scanQRCode desc",
      success: (res) => {
        console.log('扫码!',res)
        console.log('内容!',res.resultStr,)
        let info = res.resultStr
        let arr = this.state.iccidList
        arr.push(info)
        console.log('arr?', arr)
        this.setState({
          iccidList: arr
        },()=>{
          console.log('连续扫码,成功！', this.state.iccidList)
          Toast.info(info)
        })
      },
      // success: (res) => {
      //   console.log('扫码!',res)
      //   let info = res.resultStr

      //   通过查询接口验证扫描的结果正确性 
      //   axios.get('/wapi/iccid/check',{iccid:info}).then(res => {
      //     console.log('验证结果:',res)
      //   })
      //   let arr = this.state.iccidList
      //   arr.push(info)
      //   console.log('arr?', arr)
      //   this.setState({
      //     iccidList: arr
      //   },()=>{
      //     console.log('连续扫码,成功！', this.state.iccidList)
      //     Toast.info(info)
      //   })
      // },
      fail: (res)=> {
        console.log('err!',res)
      },
      complete: ()=>{
        console.log('扫码结束!',this.state.iccidList)
      }
    })
    // this.setState({
    //   iccidList: ['8986000000321239951','8986000000321239952']
    // },() => {
    //   this.creatUser2()
    // })

  }
  // 调用创建接口
  creatUser(){
    // 表单中的数据 fildsValue
    const fildsValue = this.props.form.getFieldsValue();
    console.log('fildsValue',fildsValue);
    console.log('props~',this.props)
    // 优惠月份/创建月份
    const preferentialMonths = this.state.preValidateMonth;
    console.log('preferentialMonths',preferentialMonths);
    // 优惠月份/创建月份
    const { validMonths } = fildsValue
    // 群组前缀
    const prefixName = this.props.defaultGroup.prefixName;
    console.log('prefixName',prefixName)
    console.log(this.state.getICCID)
    
    //功能组类型
    console.log('类型?',this.state.userType)
    axios
      .post("/api/user/ptt/bind/iccid",{
        prefixName:this.props.defaultGroup.prefixName,
        iccid:this.state.getICCID,
        name: fildsValue.name,
        password:fildsValue.password,
        iccidPri:fildsValue.iccidPri,
        funcsList:fildsValue.funcsList,
        monthsStr:preferentialMonths > 0 ? preferentialMonths : validMonths,
        agentpwd:fildsValue.agentpwd,
        type: this.state.userType
      }).then(res => {
        console.log(res)
        if(res && res.status === 200){
          Toast.success(res.message)
        } else if (res && res.status === 955){
          Toast.fail("该ICCID卡号已绑定平台")
        } else {
          Toast.fail(res.message)
        }
      })
  }
  creatUser2(){
    // 表单中的数据 fildsValue
    const fildsValue = this.props.form.getFieldsValue();
    console.log('fildsValue2',fildsValue);
    let iccidArr = this.state.iccidList
    console.log('props~',this.props)
    axios.post("/api/user/wechat/scanQRcode",{
      scans: iccidArr,
      name: fildsValue.name,
      password: fildsValue.password,
      qrType: 2,  // qrType表示传递的scans类型   1为imei   2为iccid
      defaultGid: this.props.defaultGroup.gid,
      joinGids: this.props.groupsGidArr,
      fgid: fildsValue.funcsList[0],
      agentpwd: fildsValue.agentpwd,
      iccidPri:fildsValue.iccidPri,
      type: this.state.userType
    }).then(res => {
      console.log('res',res)
      if(res && res.status === 200){
        Toast.success(res.message)
      } else if (res.status == 2289){
        Toast.fail('ICCID不正确!')
      } else {
        Toast.fail(res.message)
      }
    })
  }
  // 删除iccid
  onDelectIccid(item,index){
    console.log('!~',item,index)
    let iccidArr = this.state.iccidList
    iccidArr.splice(index,1)
    this.setState({
      iccidList: iccidArr
    })
  }
  //名称校验
  validateName = (rule, value, callback) => {
    if (value) {
      if (value.trim()) {
        const { form } = this.props;
        let len1 = value.length;
        if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{0,13}$/.test(value)) {
          callback(new Error("名字只支持0-11位的中文、数字、字母或下划线"));
        } else if (len1 > 11) {
          callback("批量创建名称长度不超过11");
        } else {
          callback();
        }
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
  // 验证群组 
  validateInGroups = (rule, value, callback) => {
    if (this.props.groups.length < 1) {
        callback(new Error("请选择用户所在群组"));
    } else {
        callback();
    }
  }
  // 验证默认群组
  validateDefaultGid = (rule, value, callback) => {
    let defaultGroup = this.props.defaultGroup;
    if (defaultGroup && defaultGroup.name) {
        callback();
    } else {
        callback(new Error("请选择用户默认群组"));
    }
  }
  // 验证群组前缀
  validatePrefixName = (rule,value,callback) => {
    let prefixName = this.props.defaultGroup.prefixName
    if (prefixName){
      callback();
    } else {
      callback(new Error("请选择一个群组前缀"));
    }
  }
  //验证密码
  validatePassword = (rule, value, callback) => {
    if (value) {
      if (
        /^[A-Za-z0-9]+$/gi.test(value) &&
        value.length <= 12 &&
        value.length >= 6
      ) {
        callback();
      } else {
        callback(new Error("请输入6-12位由数字和字母组成的密码"));
      }
    } else {
      callback(new Error("请输入密码"));
    }
  };
  // 验证创建月份
  validateMonths = (rule, value, callback) => {
    if (!value) {
      callback(new Error("请填写购买月数"));
    } else {
      callback();
    }
  };

  render() {
    const { drawerLeft, drawerLeftG, drawerLeftDefault,preValidateMonth, isDef, isPrefix, iccidList} = this.state
    const { groupsGidArr, groups, addDefaultGroup, defaultGroup, funcGroupList, prefixName} = this.props
    const { getFieldProps, getFieldError, setFieldsValue, getFieldDecorator, getFieldValue } = this.props.form
    
  getFieldDecorator('keys', { initialValue: [] });

  // 单选批量扫码
  const checkDefGroup =()=>{
    console.log('DefGroup!')
    this.setState({
      isDef: true,
      isPrefix: false
    })
  }
  // 单选前缀扫码
  const checkListGroup =()=>{
    console.log('ListGroup!')
    this.setState({
      isDef: false,
      isPrefix: true
    })
  }

  // ICCID优先登录勾选事件
  const onCheckIccidPri = (e) => {
    console.log(e.target.checked);
    setFieldsValue({
      iccidPri: e.target.checked ? 1 : 0,
    });
  }

  // 功能组项的点击事件
  const onChange = (e, id, item) => {
    console.log(e.target.checked, id);
    let arr = this.state.funcGidArr;
    console.log(this.state.funcGidArr)
    if (e.target.checked) {
      arr.push(item);
    } else {
      arr.splice(arr.map(item => item.id).indexOf(id), 1);
    }
    
    let currencyType = 1
      if (arr.length > 0) {
        currencyType = arr[0].currencyType
      } else {
        currencyType = 1
      }
      // 创建的账号类型
      let userType = 0
      if (currencyType == 4){
        userType= 4 
      } else {
        userType= 0
      }
    setFieldsValue({
      funcsList: arr.map(item => item.id),
    });
    this.setState({
      userType:  userType,
    })
  };

  return (
    <div className="">
      <div className="header-sticky">
        <NavBar mode="dark"
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >新建账号</NavBar>
      </div>
      <div className="sub-container">
        <List
          renderFooter={() =>
            getFieldError("name") ||
            getFieldError("password") ||
            getFieldError("gpsInterval") ||
            getFieldError("create_number") ||
            getFieldError("joinGids") ||
            getFieldError("defaultGid") ||
            getFieldError("defaultGid1") ||
            getFieldError("defaultCheckboxItem") ||
            getFieldError("funcsList") ||
            getFieldError("validMonths") ||
            getFieldError("agentpwd")
          }>
          <div>
            <InputItem
              {...getFieldProps("name", {
                rules: [
                  {
                    validator: this.validateName,
                  },
                ],
                initialValue: null,
              })}
              clear
              placeholder="请输入用户名称"
              key="1"
              maxLength="16"
              minLength="2"
            >
              名字
            </InputItem>
            <InputItem
              {...getFieldProps("password", {
                rules: [
                  { validator: this.validatePassword },
                ],
                initialValue: null,
              })}
              clear
              error={!!getFieldError("password")}
              placeholder="6-12位数字、字母组合"
              key="2"
              maxLength="12"
              type="text"
            >
              <i className="red-star">*</i>
              密码
            </InputItem>
            <Item>
              <Checkbox checked={isDef} onChange={checkDefGroup}>普通群组</Checkbox>
              <WingBlank></WingBlank>
              <Checkbox checked={isPrefix} onChange={checkListGroup}>一拖多群组</Checkbox>
            </Item>
            {isDef?(
              <div>
                <InputItem
                  {...getFieldProps("joinGids", {
                    rules: [
                      {
                        validator: this.validateInGroups,
                      },
                    ],
                    // initialValue: groupsGidArr,
                    initialValue: null
                  })}
                    className="hide-input"
                    // value={groupsGidArr}
                    value=''
                    arrow="horizontal"
                    extra={
                      <span
                        onClick={() =>
                          this.setState({ drawerLeftG: 0 })
                        }
                      >
                      {groupsGidArr.length < 1
                        ? `点击选择群组`
                        : `已选择${groupsGidArr.length}个群组`}
                        </span>
                    }
                    key="3"
                    onClick={() => this.setState({ drawerLeftG: 0 })}
                    editable="false"
                >
                    <i className="red-star">*</i>
                    所属群组
                </InputItem>
                <InputItem
                {...getFieldProps("defaultGid", {
                    rules: [
                        {
                          validator: this.validateDefaultGid,
                        },
                    ],
                    // initialValue: defaultGroup.gid,
                    initialValue: null
                })}
                className="hide-input"
                // value={defaultGroup}
                value=''
                arrow="horizontal"
                extra={
                    <div
                        style={{
                            textAlign: " right",
                            width: "50vw",
                            minWidth: "100px",
                            height: "16px",
                        }}
                        onClick={() => {
                            console.log(
                                groupsGidArr,
                                defaultGroup,
                            );
                            if (groupsGidArr.length < 1) {
                                Toast.info(
                                    "请先选择所属群组",
                                    1.5,
                                );
                            } else {
                                this.setState({
                                    drawerLeftDefault: 0,
                                });
                            }
                        }}
                    >
                        {defaultGroup && defaultGroup.name
                            ? defaultGroup.name
                            : `请选择默认群组`}
                    </div>
                }
                key="4"
                onClick={() => this.setState({ drawerLeftDefault: 0 })}
                editable="false"
            >
                <i className="red-star">*</i>
                默认群组
                </InputItem>
              </div>
            ):(
              <InputItem
              
              {...getFieldProps("defaultGid1", {
                rules: [
                  {
                    validator: this.validatePrefixName,
                  },
                ],
                initialValue: null,
              })}
              key="3"
              style={{ display: 'none' }}
              value=''
              arrow="horizontal"
              extra={
                <span
                  onClick={() =>
                    this.setState({ drawerLeft: 0 })
                  }
                >
                  {!defaultGroup
                    ? `点击选择前缀群组`
                    : `已选择-${defaultGroup.prefixName}`}
                </span>
              }
              onClick={() => this.setState({ drawerLeft: 0 })}
              editable="false"
            >
              <i className="red-star">*</i>
                前缀群组
              </InputItem>
            )}
            <List>
              <Accordion defaultActiveKey="0">
                <Accordion.Panel
                  header={
                    <div>
                      <span className="red-star">
                        *
                        </span>
                        功能组
                    </div>
                  }
                  {...getFieldProps("funcsList", {
                    rules: [
                      {
                        required: true,
                        message: "请输选择功能组"
                      },
                    ],
                  })}
                >
                  <List className="my-list">
                    {[...funcGroupList,].map(item => {
                      return (
                        <CheckboxItem
                          key={item.id}
                          onChange={e =>
                            onChange(
                              e,
                              item.id,
                              item,
                            )
                          }
                        >
                          {item.name}
                          <Item.Brief>
                            {item.remarks}
                          </Item.Brief>
                        </CheckboxItem>
                      );
                    })}
                  </List>
                </Accordion.Panel>
              </Accordion>
            </List>
            <InputItem
              {...getFieldProps("validMonths", {
                rules: [
                  {
                    validator: this.validateMonths,
                  },
                ],
                initialValue:
                  preValidateMonth > 0
                    ? (loginAdminMsg && loginAdminMsg.userValidYears == 1 ? 12 : preValidateMonth)
                    : 12,
              })}
              key="5"
              type="number"
              defaultValue={12}
              disabled={preValidateMonth > 0}
              clear
            >
              <i className="red-star">*</i>
                购买月数
            </InputItem>
            <InputItem
              {...getFieldProps("agentpwd", {
                rules: [{ required: true, message: "请输入经销商密码" }, {}],
                initialValue: null,
              })}
              clear
              type="password"
              placeholder="请输入经销商密码"
              key="9"
              labelNumber="7"
              maxLength={7}
            >
              <i className="red-star">*</i>
              经销商密码
            </InputItem>
            <CheckboxItem
              {...getFieldProps("iccidPri", {
                initialValue: 0,
              })}
              onChange={e => onCheckIccidPri(e)}
            >
              优先使用ICCID登录
            </CheckboxItem>
          </div>
        </List>
        <WingBlank>
          {/* <p>扫描到的数据:</p>
          <div style={{maxHeight:'200px',overflow:'auto'}}>
            <List>
              {iccidList.map((item, index) => {
                return (
                  <Item 
                    extra={
                      <Button 
                        size="small" 
                        type="warning" 
                        inline='true' 
                        onClick={()=> alert('删除', '是否删除该条扫码结果?', [
                          { text: '取消', onPress: () => console.log('cancel') },
                          { text: '确认', onPress: () => this.onDelectIccid(item,index) },
                        ])}
                        key={index}
                      >
                      删
                      </Button>
                    }
                  >
                    {item}
                  </Item>
              )})}
              {iccidList.length == 0? <NoneDatas /> : ""}
            </List>
          </div>
            <WhiteSpace size="xl" /> */}
            {isDef?(
              <div>
                <p>扫描到的数据:</p>
                <div style={{maxHeight:'200px',overflow:'auto'}}>
                  <List>
                    {iccidList.map((item, index) => {
                      return (
                        <Item 
                          extra={
                            <Button 
                              size="small" 
                              type="warning" 
                              inline='true' 
                              onClick={()=> alert('删除', '是否删除该条扫码结果?', [
                                { text: '取消', onPress: () => console.log('cancel') },
                                { text: '确认', onPress: () => this.onDelectIccid(item,index) },
                              ])}
                              key={index}
                            >
                            删
                            </Button>
                          }
                        >
                          {item}
                        </Item>
                    )})}
                    {iccidList.length == 0? <NoneDatas /> : ""}
                  </List>
                </div>
                <WhiteSpace size="xl" />
                <Button type="primary" onClick={() => this.DYcamera2()}>
                  批量扫码
                </Button>
                <WhiteSpace size="xl" />
                <Button type="primary" onClick={() => this.onSave()}>
                  创建账号
                </Button>
              </div>
            ):(
              <Button type="primary" onClick={() => this.onSave()}>
                扫码创建账号
              </Button>
            )}
            <WhiteSpace size="xl" />
            <Button type="" onClick={() => window.history.go(-1)}>
              返回
            </Button>
            <WhiteSpace size="xl" />
          </WingBlank>
      </div>
      <div
        style={{
          ...selectedContainer,
          left: drawerLeft + "px",
        }}
      >
        <SelectPrefixList
          defaultGroup={defaultGroup}
          addDefaultGroup={addDefaultGroup}
          handleChildClose={() =>
            this.setState({
              drawerLeft: document.body.clientWidth,
            })
          }
          history={this.props.history}
        />
      </div>
      <div
        style={{
          ...selectedContainer,
          left: drawerLeftG + "px"
        }}
      >
        <UserSelectGroups
          defaultGroup={defaultGroup}
          addDefaultGroup={addDefaultGroup}
          // uid={match.params.id}
          handleChildClose={() =>
            this.setState({
              drawerLeftG: document.body.clientWidth,
            })
          }
        />
      </div>
      <div
        style={{
          ...selectedContainer,
          left: drawerLeftDefault + "px",
          overflowY: "scroll",
          paddingBottom: "45",
        }}
      >
        <DefaultGroup
          selectList={groups}
          addDefaultGroup={addDefaultGroup}
          defaultGroup={defaultGroup}
          handleChildClose={() => {
            this.setState({
              drawerLeftDefault: document.body.clientWidth,
            });
          }}
        />
      </div>
    </div>
  )}
} 

const ClockinIccid = createForm()(ClockinICCID);
const mapStateToProps = state => {
  console.log(state.group)
  return { 
    groups: state.group.groups,
    groupsGidArr: state.group.groupsGidArr,
    defaultGroup: state.group.defaultGroup,
    funcGroupList: state.app.funcGroupList,
  };
};
// 更新redux store中的数据
const mapDispatchToProps = dispatch => {
  return {
    getFuncList: () => {
      dispatch({
        type: "app/getFuncGroupList",
        payload: {},
      });
    },
    addDefaultGroup: group => {
      
      dispatch({
        type: "group/addToDefaultGroup",
        payload: {
          group,
        },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClockinIccid);
